export class AssigneesModalController {
  constructor(localizationService) {
    'ngInject';
    this.isRTLNeeded = localizationService.shouldActivateRTL();
  }
}
